import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "cadence",
    "timed",
    "weekly",
    "monthly",
    "hour",
    "weekday",
    "dayOfMonth",
    "summary"
  ]
  static values = { timezone: String }

  connect() {
    this.update()
  }

  update() {
    const cadence = this.cadenceTarget.value

    this.toggle(this.timedTarget, ["daily", "weekly", "monthly"].includes(cadence))
    this.toggle(this.weeklyTarget, cadence === "weekly")
    this.toggle(this.monthlyTarget, cadence === "monthly")
    this.updateSummary(cadence)
  }

  updateSummary(cadence = this.cadenceTarget.value) {
    if (!this.hasSummaryTarget) return

    switch (cadence) {
      case "hourly":
        this.summaryTarget.textContent = `Runs at the top of every hour in ${this.timezoneLabel}.`
        break
      case "daily":
        this.summaryTarget.textContent = `Runs daily at ${this.hourLabel} in ${this.timezoneLabel}.`
        break
      case "weekly":
        this.summaryTarget.textContent = `Runs every ${this.weekdayLabel} at ${this.hourLabel} in ${this.timezoneLabel}.`
        break
      case "monthly":
        this.summaryTarget.textContent = `Runs monthly on day ${this.dayOfMonthTarget.value} at ${this.hourLabel} in ${this.timezoneLabel}.`
        break
      default:
        this.summaryTarget.textContent = "Runs only when started manually."
    }
  }

  toggle(element, visible) {
    element.classList.toggle("hidden", !visible)
    element.hidden = !visible
  }

  get weekdayLabel() {
    const option = this.weekdayTarget.selectedOptions[0]
    return option?.textContent?.trim() || "the selected day"
  }

  get hourLabel() {
    return `${String(this.hourTarget.value || "9").padStart(2, "0")}:00`
  }

  get timezoneLabel() {
    return this.timezoneValue || "UTC"
  }
}
